<template>
    <div class="Exanmine">
        <header class="s-icons">
<div class="order-state">
<div class="dot blue"></div>
<div class="line blue"></div>
<div class="dot blue"></div>
<div class="line grey"></div>
<div class="dot grey"></div>
</div>
<div class="s-text">
<div>提交订单</div>
<div>审核</div>
<div>审核结果</div>
</div>
        </header>
<div class="content">
    <img src="../assets/images/examine.png" alt="" width="222" height="156">
    <label style="font-weight:bold;font-size:14px;">翻译申请提交成功！</label>
    <label style="text-align:left;color:#9A9A9A;font-size:12px;padding:30px 40px;">请耐心等候翻译员审核与定价，结果将以短信通知！</label>
</div>
<footer>
    <mt-button @click="back" style="width:100%;background-color:#1E70E0;color:white;">返回首页</mt-button>
</footer>
    </div>
</template>
<script>
export default {
    name:"Examine",
    data(){
        return{

        }
    },
    methods:{
        back(){
            this.$router.push("/");
        }
    }
}
</script>
<style scoped>
.dot{
    width: 10px;
    height: 10px;
    border-radius: 50%;
}
.line{
    width: 90px;
    height: 2px;
}
.grey{background-color: #B5B5B5;}
.blue{background-color: #276CE0;}
.order-state{
    display: flex;
    justify-content: center;
    align-items: center;
}
.s-text{
    margin: 10px 0;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #5F5F5F;
    font-size: 12px;
}
.content{display: flex;flex-direction: column; justify-content: center;align-items: center;line-height: 1.5;}
</style>


// WEBPACK FOOTER //
// src/components/Examine.vue